import { render, staticRenderFns } from "./RoleSelect.vue?vue&type=template&id=06de0d84&scoped=true"
import script from "./RoleSelect.vue?vue&type=script&lang=js"
export * from "./RoleSelect.vue?vue&type=script&lang=js"
import style0 from "./RoleSelect.vue?vue&type=style&index=0&id=06de0d84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06de0d84",
  null
  
)

export default component.exports